<template>
  <div>
    <div id = 'main-content'>
      <div v-if="!examResults">
        <div v-if="examExercises && examExercises.exam && examExercises.exam.show_one_exercise">
          <div v-if="!afterLastExercise">
            <exercises-list :examExercises="[examExercises.exercises[indexOfCurrentExercise]]" :indexOffset="indexOfCurrentExercise" :exercisesNumber="examExercises.exercises.length"></exercises-list>
            <span class="pull-right text-muted">
              {{ $t('pages.exams.nextExerciseIn') }} {{ Math.floor(Math.min(timeForThisExercise, examExercises.timeLeft/1000)) }} {{$t('pages.exams.seconds')}}
              <button class="btn btn-primary btm-sm" @click="continueToNextExercise">{{$t('pages.exams.continueNextExercise')}}</button>
            </span>
            <br/>
          </div>
          <div class="text-center" v-else>
            <img src="/static/logoBW.png" style="width: 250px; height: 250px;" />
            <h4>{{ $t('pages.exams.endOfExam') }}</h4>
          </div>
        </div>
        <div v-else>
          <exercises-list :examExercises="examExercises.exercises" ></exercises-list>
        </div>
      </div>
      <exercises-list :examExercises="examExercises.examExercises" v-else-if="examExercises.examExercises"></exercises-list>
      <div v-if="!(examExercises && examExercises.exam && examExercises.exam.show_one_exercise) || afterLastExercise">
        <button id="finish-modal" @click.prevent="showModalForfinish" type="submit" class="btn btn-primary pull-right">{{$t('pages.exercise.finish')}}</button>
      </div>
      <div class="clearfix"></div>
    
      <div v-if="examExercises.timeLeft && !jeAdmin" class="examTimer">
        <div class="panel-group">
          <div :class="['panel', (examExercises.timeLeft < 30000 && Math.floor(examExercises.timeLeft/1000) % 2 === 0) ? 'panel-danger' : 'panel-default']">
            <div class="panel-heading">
              <h4 class="panel-title">
                <a data-toggle="collapse" href="#collapse1">
                  <span v-if="timeCollapsed">
                    <i class="fa fa-hourglass-end"></i>
                  </span>
                  <span v-else>{{ $t('pages.exams.timeLeft') }}</span>
                </a>
              </h4>
            </div>
            <div id="collapse1" class="panel-collapse collapse">
              <div class="panel-body">
                <div v-if="examExercises && examExercises.exam && examExercises.exam.show_one_exercise">
                  <!-- time for this exercise -->
                  <div>
                    <label>{{ $t('pages.exams.timeForThisExercise') }}</label><br/>
                    <span v-if="Math.min(timeForThisExercise, examExercises.timeLeft/1000) > 60">{{Math.floor(Math.min(timeForThisExercise, examExercises.timeLeft/1000)/60)}} {{ $t('pages.exams.minutes') }} </span>
                    {{(Math.floor(Math.min(timeForThisExercise, examExercises.timeLeft/1000))) % 60}} {{ $t('pages.exams.seconds') }}<br>
                    <span v-if="seated">{{ $t('pages.exams.seatingPosition') }}: <a>{{selectedSeat}}</a></span>
                  </div>
                  <label>{{ $t('pages.exams.timeForExam') }}</label><br/>
                  <span v-if="examExercises.timeLeft/1000 > 60">{{Math.floor(examExercises.timeLeft/1000/60)}} {{ $t('pages.exams.minutes') }} </span>
                  {{(Math.floor(examExercises.timeLeft/1000)) % 60}} {{ $t('pages.exams.seconds') }}<br>
                  <span v-if="seated">{{ $t('pages.exams.seatingPosition') }}: <a>{{selectedSeat}}</a></span>
                </div>
                <div v-else>
                  <span v-if="examExercises.timeLeft > 60000">{{Math.floor(examExercises.timeLeft/1000/60)}} {{ $t('pages.exams.minutes') }} </span>
                  {{(Math.floor(examExercises.timeLeft/1000)) % 60}} {{ $t('pages.exams.seconds') }}<br>
                  <span v-if="seated">{{ $t('pages.exams.seatingPosition') }}: <a>{{selectedSeat}}</a></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
      </div>
      
      <div class="modal modal-default fade" id="modal-finish-exercises">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-primary">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">{{ $t('pages.exams.finish') }}</h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <p>{{ $t('pages.exams.areYouSure') }}</p>
              </div>
              <div class="form-group">
                <table class="table">
                  <tbody>
                  <tr>
                    <th>{{ $t('pages.exams.examinationInfo')}}:</th>
                  </tr>
                  <tr><td>
                    {{ $t('pages.exams.timeLeft') }}: <span v-if="examExercises.timeLeft > 60000">{{Math.floor(examExercises.timeLeft/1000/60)}} {{ $t('pages.exams.minutes') }} </span>
                    {{(Math.floor(examExercises.timeLeft/1000)) % 60}} {{ $t('pages.exams.seconds') }}<br/>
                    <span v-if="examInfo.maxRetries > 0">{{ $t('pages.exams.allowedAttempts') }}: {{examInfo.maxRetries}}<br/></span>
                    <span v-else>{{ $t('pages.exams.allowedAttempts') }}: {{ $t('pages.exams.noLimit') }}<br/></span>
                    <span>{{ $t('pages.exams.thisAttemptNumber') }}: {{examExercises.retriesCount}}</span><br/>
                  </td></tr>
                  </tbody>
                </table>
              </div>
              <div class="form-group">
                <table class="table">
                  <tbody>
                  <tr>
                    <th>{{ $t('pages.exams.exercisesList')}}:</th>
                  </tr>
                  <tr v-for="(exercise, index) in examExercises.exercises" v-if="exercise"><td>
                    <!-- $options.filters.pickTranslation(exercise.title) ||  -->
                    {{ $t("pages.exercise.name") + " " + (index+1) }}
                    <ul>
                      <li v-for="(question, i) in exercise.questions"> {{ $t("pages.exams.question") }} {{i + 1}}:
                        <span v-if="question.submittedAnswer" class="label label-success">{{ $t("pages.exams.answered") }}</span>
                        <span v-else class="label label-warning">{{ $t("pages.exams.notAnswered") }}</span>
                      </li>
                    </ul>
                  </td></tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer bg-primary">
              <button type="button" class="btn btn-default pull-left" data-dismiss="modal">{{ $t('pages.buttons.cancel') }}</button>
              <button type="button" class="btn btn-danger" data-dismiss="modal" @click.prevent="finishExam"> {{ $t('pages.buttons.confirm') }} </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
    </div>

  </div>
</template>

<script>
import ExercisesList from '@/components/exercises/ExercisesList'
import Rest from './../../services/rest'
import router from './../../router/router'
import { mapGetters } from 'vuex'
import Exercises from '@/components/exercises/Exercises'

export default {
  data () {
    return {
      examExercises: {isShown: true},
      examInfo: {},
      title: '',
      timeCollapsed: true,
      previousTime: 0,
      selectedSeat: '',
      seated: false,
      milliSecondsSolving: 0,
      examLocalData: {
        currentExerciseIndex: 0,
        examAttemptId: 0
      }
    }
  },
  props: {
    classExamId: '',
    gid: '',
    yid: '',
    sid: '',
    exerciseGroup: ''
  },
  created () {
    this.fetchExamExercises()
  },
  computed: {
    ...mapGetters({
      jeAdmin: 'hasAdminRole'
    }),
    examResults () {
      return this.$route.name === 'classExamResults' || this.$route.name === 'classExamResultsAdmin' || this.$route.name === 'ratingResults'
    },
    ratingExam () {
      return this.$route.name === 'ratingExam'
    },
    timeForAllExercises () {
      let seconds = 0
      for (let i = 0; i < this.examExercises.exercises.length; i++) {
        seconds += this.examExercises.exercises[i].exerciseSeconds
      }
      return seconds
    },
    afterLastExercise () {
      return this.milliSecondsSolving / 1000 > this.timeForAllExercises || this.examLocalData.currentExerciseIndex >= this.examExercises.exercises.length
    },
    indexOfCurrentExercise () {
      let seconds = this.milliSecondsSolving / 1000
      let i = 0
      while (seconds > 0 && i < this.examExercises.exercises.length) {
        seconds -= this.examExercises.exercises[i].exerciseSeconds
        i++
      }
      return Math.min(Math.max(Math.max(0, i - 1), this.examLocalData.currentExerciseIndex), this.examExercises.exercises.length - 1)
    },
    timeForThisExercise () {
      let seconds = this.milliSecondsSolving / 1000
      let allowedTime = 0
      for (let i = 0; i <= this.indexOfCurrentExercise; i++) {
        allowedTime += this.examExercises.exercises[i].exerciseSeconds
      }
      return Math.max(0, allowedTime - seconds)
    },
    timeLeftForAll () {
      return Math.max(this.timeForAllExercises - this.milliSecondsSolving / 1000, 0)
    }
  },
  methods: {
    continueToNextExercise () {
      this.examLocalData.currentExerciseIndex = Math.min(this.indexOfCurrentExercise + 1, this.examExercises.exercises.length)
      localStorage.setItem('examLocalData', JSON.stringify(this.examLocalData))
    },
    prepareComponent () {
      this.$store.dispatch('getGroup', {
        gid: this.gid,
        yid: this.yid,
        sid: this.sid
      })
      this.$store.commit('updateAdminBreadcrumbs', [{path: '', name: {'en-us': this.title, sl: this.title}}])
    },
    fetchExamExercises () {
      if (this.examResults) {
        return Rest.request('GET', `/classExams/any/attempts/${this.classExamId}`).then((data) => {
          this.examExercises = Object.assign({}, this.examExercises, data)
          this.title = data.title
          this.$set(this.examExercises, 'isShown', false)
        }).catch((err) => {
          console.log(err)
        })
      } else {
        return Rest.request('GET', `/classExams/${this.classExamId}`).then((data) => {
          this.examExercises = Object.assign({}, this.examExercises, data)
          this.milliSecondsSolving = this.examExercises.duration - this.examExercises.timeLeft
          this.title = data.title
          this.$set(this.examExercises, 'isShown', false)

          // one exercise at a time data
          this.examLocalData.examAttemptId = this.examExercises.examAttemptId
          if (localStorage.getItem('examLocalData')) {
            let storedLocalExamData = JSON.parse(localStorage.getItem('examLocalData'))
            if (storedLocalExamData.examAttemptId === this.examExercises.examAttemptId) {
              this.examLocalData = storedLocalExamData
            }
          }

          if (data.exam.liveTest) {
            this.checkIfSeated()
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    getExamInfo () {
      return Rest.request('GET', `/classExams/${this.classExamId}/status`).then((data) => {
        this.examInfo = data
      }).catch((err) => {
        console.log(err)
      })
    },
    finishExam () {
      let postdata = {
        id: this.classExamId
      }
      return Rest.request('POST', `/classExams/${this.classExamId}/finish`, postdata).then((data) => {
        if (this.ratingExam) {
          router.push({name: 'ratingResults', params: {attemptId: this.examExercises.examAttemptId}})
        } else {
          router.push({
            name: 'exercises',
            params: {gid: this.$route.params.gid, yid: this.$route.params.yid, sid: this.$route.params.sid}
          })
        }
      }).catch((err) => {
        console.log(err)
        Rest.request('POST', `/classExams/manuallyCloseOvertimeExams`, postdata).then((data) => {
        })
        if (this.ratingExam) {
          router.push({name: 'ratingResults', params: {attemptId: this.examExercises.examAttemptId}})
        } else {
          router.push({
            name: 'exercises',
            params: {gid: this.$route.params.gid, yid: this.$route.params.yid, sid: this.$route.params.sid}
          })
        }
      })
    },
    showModalForfinish () {
      if (this.examResults) {
        router.push({name: 'exercises', params: {gid: this.$route.params.gid, yid: this.$route.params.yid, sid: this.$route.params.sid}})
      } else if (this.jeAdmin) {
        this.finishExam()
      } else {
        this.fetchExamExercises()
        this.getExamInfo()
        window.jQuery('#modal-finish-exercises').modal()
      }
    },
    updateTimeSecond () {
      var currentTime = new Date().valueOf()
      this.examExercises.timeLeft -= (currentTime - this.previousTime)
      this.milliSecondsSolving += (currentTime - this.previousTime)
      if (Math.floor(this.examExercises.timeLeft / 30000) < Math.floor((this.examExercises.timeLeft + (currentTime - this.previousTime)) / 30000)) {
        // vsakih 30 sekund
        this.fetchExamExercises()
      }
      this.previousTime = currentTime
      if (!this.jeAdmin && (this.examExercises.timeLeft <= 0 || !this.examExercises.isSolving)) {
        this.timeIsUpFinish()
      }
    },
    timeIsUpFinish () {
      clearInterval(this.$options.interval)
      this.finishExam()
    },
    isTimeCollapsed () {
      return window.jQuery('#collapse1').hasClass('collapsed')
    },
    checkIfSeated () {
      return Rest.request('GET', `/classExams/${this.classExamId}/checkIfSeated`).then((data) => {
        if (data.seatID) {
          this.selectedSeat = data.seatID
          this.seated = true
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  components: {
    'exercises-list': ExercisesList,
    'exercises': Exercises
  },
  mounted () {
    this.fetchExamExercises().then(() => {
      this.prepareComponent()
      let $ = window.jQuery
      let tren = this
      this.$nextTick(function () {
        this.previousTime = new Date().valueOf()
        if (!this.jeAdmin && !this.examResults) {
          if (window.innerWidth > 1400) {
            $('#collapse1').addClass('in')
            tren.timeCollapsed = false
          }
          $('#collapse1').on('shown.bs.collapse', function () {
            console.log('odprto')
            tren.timeCollapsed = false
          })

          $('#collapse1').on('hidden.bs.collapse', function () {
            console.log('zaprto')
            tren.timeCollapsed = true
          })
          tren.$options.interval = setInterval(tren.updateTimeSecond, 1000)
        }
      })
    })
  },
  beforeDestroy () {
    clearInterval(this.$options.interval)
    // window.jQuery('.modal-backdrop.in').hide()
  }
}
</script>

<style>

.examTimer {
  position: fixed;
  left: 0px;
  top: 100px;
}

.list-group-item {
  background-color: transparent !important;
  border-top: 1px solid #ddd !important;
  border-left: transparent !important;
  border-right: transparent !important;
  border-radius: 0 !important;
}

@media print {
   #finish-modal {
     display: none;
  }
}


</style>





// WEBPACK FOOTER //
// ExamExercise.vue?2e22ffd6